import { FC } from 'react';
import { Box, DialogContentText, TextField, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import {
	getEuDdpRequestShipmentData,
	getEuDdpS10Error,
	getEuDdpS10IsLoad,
} from 'redux/reducers/euDdp/selectors';
import { TStepS10ExpectedProps } from './types';
import { getEmAssignment } from 'redux/reducers/settings/selectors';
import { EasTableValue } from 'ui/EasTable/EasTableValue';
import { ETableStructureType } from 'services/constants/tableStructureTypes';
import { AmountAndCurrency } from 'ui/AmountAndCurrency';
import { DeliveryAddressChangedNotice } from '../DeliveryAddressChangedNotice';

export const StepS10Expected: FC<TStepS10ExpectedProps> = ({ s10Number, setS10Number }) => {
	const requestShipmentData = useSelector(getEuDdpRequestShipmentData);
	const s10Loading = useSelector(getEuDdpS10IsLoad);
	const s10Error = useSelector(getEuDdpS10Error);
	const emAssignment = useSelector(getEmAssignment);
	const registeredCountryName = emAssignment?.registeredCountryName;

	return (
		<>
			<DialogContentText>
				By providing the S10 tracking number, you confirm that the parcel has been shipped to the
				address below.
			</DialogContentText>
			<DeliveryAddressChangedNotice />
			<Box sx={{ mt: 2 }}>
				<Typography sx={{ fontSize: '.875rem', fontWeight: 'bold' }}>Delivery address:</Typography>
				<Box sx={{ mt: 1, fontSize: '.875rem', color: 'text.secondary' }}>
					<Typography sx={{ fontSize: 'inherit' }}>
						Receiver name (Company name): EASY ACCESS SYSTEM EUROPE OÜ
					</Typography>
					<Typography sx={{ fontSize: 'inherit' }}>
						Receiver Address: Mustika postkontor, Karjavälja 4, 12918 Tallinn, Estonia
					</Typography>
					<Typography sx={{ fontSize: 'inherit' }}>
						Receiver email: omniva@easproject.com
					</Typography>
					<Typography sx={{ fontSize: 'inherit' }}>Receiver phone: +37256900548</Typography>
				</Box>
				<Typography sx={{ mt: 1.5, fontSize: '.875rem', fontWeight: 'bold' }}>
					Your payment of{' '}
					{AmountAndCurrency({
						amount: requestShipmentData?.totalAmount || 0,
						currency: 'EUR',
						bold: true,
					})}{' '}
					will be processed once the S10 number is accepted.
					<br />
					Please note that the delivery cost becomes non-refundable once confirmed.
				</Typography>
			</Box>
			<Box sx={{ mt: 2 }}>
				<TextField
					label="S10 Number"
					variant="outlined"
					fullWidth
					size="small"
					value={s10Number}
					onChange={(e) => setS10Number(e.target.value)}
					disabled={s10Loading}
					error={!!s10Error}
					helperText={s10Error}
					sx={{ mt: 1, '& .MuiInputBase-root': { borderRadius: '12px' } }}
				/>
			</Box>
		</>
	);
};
